<template>
</template>

<script>
export default {
  name: 'LastWorkout',

  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>
